export default "__VITE_PUBLIC_ASSET__3dd585c8__"